import { useCallback, memo } from 'react';
import copy from 'copy-to-clipboard';
import { IconButtonProps } from '@mui/material/IconButton';
import CopyIcon from '../../icons/CopyIcon';
import IconButton from '../IconButton';
import { AB3 } from '../../theme';

export interface ICopyToClipboardButton extends IconButtonProps {
  text: string;
  onCopy?: () => void;
}

const CopyToClipboardButton = (props: ICopyToClipboardButton) => {
  const {
    text, color = AB3, onCopy, ...rest
  } = props;
  const handleClick = useCallback(() => {
    copy(text);
    if (onCopy) {
      onCopy();
    }
  }, [text, onCopy]);

  return <IconButton onClick={handleClick} {...rest}><CopyIcon color={color} /></IconButton>;
};

export default memo(CopyToClipboardButton);
